// extracted by mini-css-extract-plugin
module.exports = {"comp":"Nav_comp__S5uOw"};